import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useApp();

  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition duration-300 group">
      
      {/* Image */}
<div className="relative overflow-hidden h-96 bg-gray-50">
  <img
    src={product.image}
    alt={product.name}
    className="w-full h-full object-cover object-top group-hover:scale-105 transition duration-300"
  />
  {product.featured && (
    <span className="absolute top-3 left-3 bg-secondary text-white text-xs font-bold px-2 py-1 rounded-full">
      Populaire
    </span>
  )}
  {product.stock === 0 && (
    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <span className="text-white font-bold text-lg">Rupture de stock</span>
    </div>
  )}
</div>

      {/* Infos */}
      <div className="p-4">
        <span className="text-xs text-secondary font-semibold uppercase tracking-wide">
          {product.category}
        </span>
        <h3 className="text-gray-800 font-semibold text-lg mt-1 mb-2 line-clamp-1">
          {product.name}
        </h3>
        <p className="text-gray-500 text-sm line-clamp-2 mb-4">
          {product.description}
        </p>

        <div className="flex items-center justify-between">
          <span className="text-primary font-bold text-xl">
            {product.price.toLocaleString()} FCFA
          </span>
          <div className="flex gap-2">
            <Link
              to={`/produit/${product._id}`}
              className="bg-gray-100 text-gray-700 px-3 py-2 rounded-lg text-sm hover:bg-gray-200 transition"
            >
              Voir
            </Link>
            <button
              onClick={() => addToCart(product)}
              disabled={product.stock === 0}
              className="bg-primary text-white px-3 py-2 rounded-lg text-sm hover:bg-blue-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Ajouter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;